import React from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import { Link } from 'react-router-dom';

const UserMenu = loadable(() => import('./UserMenu'));
const SearchBar = loadable(() => import('./SearchBar'), { ssr: false });
import ChannelListMenu from './ChannelListMenu';
import PurchaseMenu from './PurchaseMenu';

import { isAuthenticatedSelector } from '../../selector/user';
import { desktopChannelListSelector } from '../../selector/channel';

import appendQueryString from '../../utils/appendQueryString';
import { desktopHeaderClick } from '../../utils/ga/category06';

import { TRACKING_PAGEVIEW_SOURCE } from '../../../constants/tracking';
import imageSrc from '../../../common/image';

function appendPageViewSource(url) {
  return appendQueryString(url, {
    source: TRACKING_PAGEVIEW_SOURCE.NAVBAR,
  });
}

function HeaderDesktop(props) {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const channels = useSelector(desktopChannelListSelector);

  return (
    <nav
      className="h-full px-12 flex items-center flex-nowrap text-brand-grey-800"
      itemType="http://www.schema.org/SiteNavigationElement"
    >
      <Link
        className="flex-none h-6 w-32 mr-6"
        to={appendPageViewSource('/')}
        alt="LINE TV"
        onClick={() => desktopHeaderClick('LINE TV')}
      >
        <img src={`${imageSrc}/logo/logo.svg`} className="h-full w-auto" alt="LINE TV" />
      </Link>

      <ChannelListMenu
        data={channels}
        className="flex-none text-14 font-500 leading-none mx-4 h-full flex items-center justify-center"
        style={{ minWidth: '48px' }}
      />

      <PurchaseMenu className="flex-none mx-4 h-full flex items-center text-14 font-500 hover:underline" />

      <Link
        to={appendPageViewSource('/feed/campaign')}
        className="flex-none text-14 font-500 leading-none mx-4 hover:underline"
        onClick={() => desktopHeaderClick('活動')}
      >
        活動
      </Link>

      <SearchBar className="flex-none ml-auto text-brand-black" style={{ width: '314px', height: '34px' }} />

      <div className="flex-none ml-8 h-full flex items-center" style={{ minWidth: '68px' }}>
        {isAuthenticated && <UserMenu className="text-brand-black h-full flex items-center" />}
      </div>
    </nav>
  );
}

export default HeaderDesktop;
